const { VITE_HIDE_HOME } = import.meta.env;
const Layout = () => import("@/layout/index.vue");

export default {
  path: "/",
  name: "Home",
  component: Layout,
  redirect: "/welcome",
  meta: {
    icon: "ep/home-filled",
    title: "首页",
    rank: 0
  },
  children: [
    {
      path: "/welcome",
      name: "Welcome",
      component: () => import("@/views/welcome/index.vue"),
      meta: {
        title: "首页",
        showLink: VITE_HIDE_HOME === "true" ? false : true
      }
    },
    {
      path: "/cgfx",
      name: "Cgfx",
      component: () => import("@/views/welcome/indexCg.vue"),
      meta: {
        title: "首页",
        showLink: VITE_HIDE_HOME === "true" ? false : true
      }
    },
    {
      path: "/reportAnalyze",
      name: "ReportAnalyze",
      component: () => import("@/views/reportAnalyze/index.vue"),
      meta: {
        title: "报表分析",
        showLink: true
      }
    }
  ]
} satisfies RouteConfigsTable;
